import React from 'react';
import './Loader.css';

const Loader = ({ texto = "Cargando..." }) => {
  return (
    <div className="loader-container">
      <div className="spinner"></div>
      <p className="loader-text">{texto}</p>
    </div>
  );
};

export default Loader;